import React, {useRef} from 'react';
import {Button, Tooltip, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const UploadFilesForm = ({
                             handleUpload,
                             selectedFiles,
                             setSelectedFiles,
                             label,
                             uploadData,
                             multiple = true,
                             disableImport
                         }) => {
    const inputRef = useRef(null);
    const inputId = `upload-file-${uploadData?.id}`;

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
    };

    const openFilePicker = () => {
        inputRef.current?.click();
    };

    return (
        <div>
            <form onSubmit={handleUpload} style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                <input
                    ref={inputRef}
                    id={inputId}
                    type="file"
                    hidden
                    multiple={multiple}
                    onChange={handleFileSelect}
                />
                <Box sx={{display: "flex", gap: "10px"}}>
                    <Box
                        sx={{
                            display: "flex",
                            gap: "8px",
                            width: 350,
                            borderRadius: "4px",
                            padding: "4px 8px",
                            boxSizing: "border-box",
                            border: (theme) => `${theme.palette.primary.main} 1px solid`,
                            alignItems: "center",
                            "& label p": {
                                textAlign: "center",
                                width: 133,
                                height: 24,
                                fontSize: "16px",
                                borderRadius: "4px",
                                backgroundColor: (theme) => theme.palette.primary.light,
                                cursor: "pointer",
                            }
                        }}>
                        <label htmlFor={inputId}>
                            <Typography>{multiple ? "Выбрать файлы" : "Выбрать файл"}</Typography>
                        </label>
                        <Typography
                            sx={{fontSize: "16px"}}>
                            {selectedFiles?.length === 1 ? selectedFiles[0].name : selectedFiles?.length === 0 || selectedFiles === null || !multiple ? (multiple ? "Файлы не выбраны" : "Файл не выбран") : `${selectedFiles?.length} файла `}
                        </Typography>
                    </Box>
                    <Tooltip sx={{height: "36px"}} arrow placement="top"
                             title={disableImport ? "Введите серию и наименование материала" : ""}>
                        <Box
                            component="span"
                            sx={{
                                display: "inline-flex",
                                cursor: disableImport ? "default" : "pointer",
                            }}
                            onClick={() => {
                                if (disableImport) return;
                                if (!selectedFiles?.length) openFilePicker();
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!selectedFiles || selectedFiles?.length === 0 || disableImport}
                                sx={{
                                    height: 36,
                                    width: 206,
                                    padding: "5px",
                                    fontWeight: 500,
                                    fontSize: "0.7rem",
                                    lineHeight: 1.75,
                                    letterSpacing: "0.02857em",
                                    borderRadius: "4px",
                                    border: '1px solid #3B8BEB',
                                    zIndex: 0,
                                    cursor: "pointer",
                                    bgcolor: (theme) => theme.palette.primary.main,
                                    "&:hover": {
                                        bgcolor: (theme) => theme.palette.primary.main,
                                        boxShadow: "0 0 0 0.2rem #C4DBF6"
                                    },
                                    '&:disabled': {
                                        bgcolor: (theme) => theme.palette.primary.stroke,
                                        color: (theme) => theme.palette.text.light,
                                        border: "none",
                                        cursor: "pointer",
                                        pointerEvents: "none",
                                    }
                                }}
                                type="submit"
                                value={label}
                            >
                                {label}
                            </Button>
                        </Box>
                    </Tooltip>
                    <Tooltip sx={{height: "36px"}} arrow placement="top"
                             title={uploadData?.helpText || label}>
                        <HelpOutlineIcon/>
                    </Tooltip>
                </Box>
                <ul style={{
                    display: "flex",
                    gap: "10px",
                    height: "30px",
                    listStyleType: "none",
                    padding: 0,
                    margin: 0
                }}>
                    {selectedFiles?.map((file, index) => (
                        <li key={index} style={{padding: "5px 0"}}>
                            {file.name},
                        </li>
                    ))}
                </ul>

            </form>
        </div>
    );
};

export default UploadFilesForm;